import { render, staticRenderFns } from "./GoalHistory.vue?vue&type=template&id=1467d25b&"
import script from "./GoalHistory.vue?vue&type=script&lang=js&"
export * from "./GoalHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports